'use strict';
angular.module('initWebsiteDataModule', []).factory('initWebsiteDataService', [
    function() {
        return {
            initNews: function() {
                var list = {
                    METADATAID: 0,
                    TITLECOLOR: '',
                    TITLE: '',
                    RELEASESOURCE: '',
                    ORIGINALTITLE: '',
                    ORIGINALADDRESS: '',
                    TEMPLATESETTING: '',
                    HOMETITLE: '',
                    AUTHOR: '',
                    MOVETITLE: '',
                    KEYWORDS: '',
                    RELATEDNEWS: '',
                    DOC_PICTURELIST: [],
                    SUBJECTOFOWNERSHIP: '',
                    ATTRIBUTIONLABEL: '',
                    ABSTRACT: '',
                    CONTENT: '',
                    HTMLCONTENT: '',
                    DOCWORDSCOUNT: 0,
                    ISCONTAINSENSITIVEWORDS: 0,
                    SENSITIVEWORDS: '',
                    ADDITIONALTEXTTOP: '',
                    ADDITIONALTEXTBOTTOM: '',
                    ADDITIONALTEXTLEFT: '',
                    ADDITIONALTEXTRIGHT: '',

                    /* "READINGPICS": [{
                    "APPFILE": "",
                    "APPDESC": ""
                }],*/
                    TEMPNAME: {
                        name: '请选择模板',
                        value: 0,
                    },
                    OUTLINEPICS: [
                        {
                            APPFILE: '',
                            APPDESC: '',
                        },
                    ],
                    AUDIOVIDEO: '',
                    // "ISSUETIME": "",
                    EDIT: '',
                    ISNOPAYMENT: '1',
                    DOCGENRE: '',
                    DOCSOURCENAME: '',
                    FGD_EDITINFO: [],
                    FGD_AUTHINFO: [
                        {
                            isCreate: true,
                        },
                    ], // 用于判断发稿单是否是新建状态
                    STATE: '',
                    DOCSOURCE: '',
                    REMARKS: '',
                    MEDIATYPES: 2,
                    TEMPID: '0',
                    ORIGINAL: '0',
                    ATTACHFILE: [],
                    SUBTITLE: '',
                    LEADTITLE: '',
                    EDITORTRUENAME: '',
                    CUSTOMTIME: '',
                    AUDIOVIDEOURL: '',
                };
                return list;
            },
            initAtlas: function() {
                var list = {
                    METADATAID: 0,
                    TITLECOLOR: '',
                    TITLE: '',
                    RELEASESOURCE: '',
                    SUBTITLE: '',
                    LEADTITLE: '',
                    NEWSSOURCES: '',
                    TEMPLATESETTING: '',
                    SIGNATUREAUTHOR: '',
                    CONTRIBUTORS: '',
                    KEYWORDS: '',
                    AUDIOVIDEO: '',
                    CONABSTRACT: '',
                    DOCGENRE: '',
                    ISNOPAYMENT: '1',
                    // "ISSUETIME": "",
                    DOC_PICTURELIST: [],
                    SOURCEMETAID: '',
                    MEDIATYPE: '2',

                    /* "READINGPICS": [{
                    "APPFILE": "",
                    "APPDESC": ""
                }],*/
                    OUTLINEPICS: [
                        {
                            APPFILE: '',
                            APPDESC: '',
                        },
                    ],
                    FLOWVERSIONTIME: '',
                    DOCTYPE: '',
                    DOCWORDSCOUNT: 0,
                    FGD_EDITINFO: [],
                    FGD_AUTHINFO: [
                        {
                            isCreate: true,
                        },
                    ], // 用于判断发稿单是否是新建状态
                    STATE: '',
                    DOCSOURCE: '',
                    REMARKS: '',
                    DOCSOURCENAME: '',
                    TEMPNAME: {
                        name: '请选择模板',
                        value: 0,
                    },
                    TEMPID: '0',
                    RELATEDNEWS: '',
                    ORIGINAL: '0',
                    ATTACHFILE: [],
                    CONTENT: '',
                    ATTRIBUTIONLABEL: '',
                    EDITOR: '',
                    HTMLCONTENT: '',
                    EDITORTRUENAME: '',
                    CUSTOMTIME: '',
                    AUDIOVIDEOURL: '',
                    ISCONTAINSENSITIVEWORDS: 0,
                    SENSITIVEWORDS: '',
                };
                return list;
            },
            initLinkDoc: function() {
                var list = {
                    METADATAID: 0,
                    CHANNELID: '',
                    TITLECOLOR: '',
                    TITLE: '',
                    DOCSOURCENAME: '',
                    DOC_PICTURELIST: [],
                    ORIGINALTITLE: '',
                    ORIGINALADDRESS: '',
                    HOMETITLE: '',
                    AUTHOR: '',
                    MOVETITLE: '',
                    ATTRIBUTIONLABEL: '',
                    ABSTRACT: '',
                    COMMENTSETTINGS: '',
                    CUSTOMTIME: '',
                    // "ISSUETIME": "",
                    HITS: '',
                    DOCSOURCE: '',
                    REMARKS: '',
                    SRCURL: '',
                    ORIGINAL: '0',
                    CONTENT: '',
                    ATTACHFILE: [],
                    SUBTITLE: '',
                    LEADTITLE: '',
                    EDITOR: '',
                    OUTLINEPICS: [
                        {
                            APPFILE: '',
                            APPDESC: '',
                        },
                    ],
                    ISCONTAINSENSITIVEWORDS: 0,
                    SENSITIVEWORDS: '',
                    ISNOPAYMENT: '1',
                    DOCGENRE: '',
                    FGD_EDITINFO: [],
                    FGD_AUTHINFO: [
                        {
                            isCreate: true,
                        },
                    ],
                };
                return list;
            },
            initSubject: function() {
                var list = {
                    SERVICEID: 'mlf_website',
                    METADATAID: 0,
                    CHANNELID: '',
                    TITLE: '',
                    SPECIALCONTENT: '',
                    AUTHOR: '',
                    OUTLINEPICS: [
                        {
                            APPFILE: '',
                            APPDESC: '',
                        },
                    ],
                    SPECIALFILE: [],
                    CUSTOMTIME: '',
                    ISCONTAINSENSITIVEWORDS: 0,
                    SENSITIVEWORDS: '',
                    ISNOPAYMENT: '1',
                    DOCGENRE: '',
                    FGD_EDITINFO: [],
                    FGD_AUTHINFO: [
                        {
                            isCreate: true,
                        },
                    ],
                };
                return list;
            },

            /**
             * [initVideo description] 初始化视频稿
             * @return {[type]} [description]
             */
            initVideo() {
                return {
                    METADATAID: 0,
                    CHANNELID: 0,
                    TITLE: '',
                    VIDEOID: 0,
                    HTMLCONTENT: '',
                    CONTENT: '',
                    NEWSSOURCES: '',
                    KEYWORDS: '',
                    ABSTRACT: '',
                    DOCWORDSCOUNT: 0,
                    ORIGINAL: 0,
                    VIDEOREL: [],
                    CONTRIBUTORSAUTHER: '',
                    ORIGINALTYPE: '',
                    SPECIALDOC: '',
                    ORIGINALTITLE: '',
                    ORIGINALADDRESS: '',
                    HOMETITLE: '',
                    AUTHOR: '',
                    DOC_PICTURELIST: [],
                    SENSITIVEWORDS: '',
                    TEMPNAME: {
                        name: '请选择模板',
                        value: 0,
                    },
                    OUTLINEPICS: [
                        {
                            APPFILE: '',
                            APPDESC: '',
                        },
                    ],
                    ISNOPAYMENT: 1,
                    DOCGENRE: '',
                    REMARKS: '',
                    ATTACHFILE: [],
                    SUBTITLE: '',
                    LEADTITLE: '',
                    EDITORTRUENAME: '',
                    CUSTOMTIME: '',
                    AUDIOVIDEOURL: '',
                    FGD_EDITINFO: [],
                    FGD_AUTHINFO: [
                        {
                            isCreate: true,
                        },
                    ],
                };
            },
        };
    },
]);
